import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c09a5b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-panel" }
const _hoisted_2 = { class: "el-dropdown-link" }
const _hoisted_3 = { class: "user-info" }
const _hoisted_4 = { style: {"font-size":"12px"} }
const _hoisted_5 = { class: "dialog-footer" }

import { reactive, ref } from 'vue';
import message from './message.vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router';
import { ElMessage, ElNotification, FormInstance, FormRules } from 'element-plus';
import { resetPswd } from '@/api';
import { watch } from 'vue';

// export default defineComponent({

// setup() {

export default /*#__PURE__*/_defineComponent({
  __name: 'panel',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const user = reactive(store.state.user);
const logout = () => {
    store.dispatch('user/logout').then(() => {
        router.push(`/login?redirect=${route.fullPath}`)
    }).catch(() => {
        ElMessage.error('退出失败');
    })
}

const dialog = ref(false);
const formRef = ref<FormInstance>()
const form = reactive({
    oldPswd: '',
    newPswd: '',
    checkPswd: '',
});
const checkStatus = ref(true);
watch(() => form.checkPswd, (val) => {
    if (form.newPswd !== val) {
        checkStatus.value = false;
    } else {
        checkStatus.value = true;
    }
})

const rules = reactive<FormRules>({
    oldPswd: [
        { required: true, message: '请输入旧密码', trigger: 'blur' }],
    newPswd: [
        {
            required: true, trigger: 'blur',
            validator: (rule: any, password: any, callback: any) => {
                const minLength = 8;
                const hasUpperCase = /[A-Z]/.test(password);
                const hasLowerCase = /[a-z]/.test(password);
                const hasNumber = /[0-9]/.test(password);
                const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);

                // 统计满足的条件数量
                const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar]
                    .filter(Boolean).length;

                // 检查长度和条件数量
                if (password.length >= minLength && criteriaMet >= 3) {
                    callback()
                } else {
                    callback(new Error("长度不少于8位，含大写字母、小写字母、数字和特殊字符中的3种"))
                }
            },
        },],
    checkPswd: [
        {
            required: true, trigger: 'blur',
            validator: (rule: any, password: any, callback: any) => {
                if (password !== form.newPswd) {
                    callback(new Error("密码不一致"))
                } else {
                    callback()
                }
            },
        },],
})
const updataPswd = async (formEl: FormInstance | undefined) => {
    if (!formEl) return
    await formEl.validate((valid, fields) => {
        if (valid) {
            resetPswd({ newPswd: form.newPswd, oldPswd: form.oldPswd }).then(() => {
                ElNotification.success({ message: "操作成功" })
                dialog.value = false;
            })
        }
    })
}
const resetForm = (formEl: FormInstance | undefined) => {
    if (!formEl) return
    formEl.resetFields()
}
// return { logout, user }
// }
// })


return (_ctx: any,_cache: any) => {
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(message),
      _createVNode(_component_el_dropdown, {
        trigger: "click",
        style: {"color":"#fff"}
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("修改密码")
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, {
                onClick: logout,
                divided: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Switch)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" 退出 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, [
            _createVNode(_component_el_icon, {
              size: "21",
              style: {"margin":"auto 5px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserFilled)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, "[ " + _toDisplayString(user.roleName) + " ]", 1),
              _createElementVNode("b", null, _toDisplayString(user.name), 1)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialog).value = $event)),
      onClosed: _cache[6] || (_cache[6] = ($event: any) => (resetForm(formRef.value))),
      title: "修改密码",
      width: "40%",
      style: {"min-width":"350px"}
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: !checkStatus.value,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (updataPswd(formRef.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确认 ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: form,
          ref_key: "formRef",
          ref: formRef,
          rules: rules,
          "label-width": "100px",
          style: {"max-width":"500px","margin":"0 auto"},
          "status-icon": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "旧密码",
              prop: "oldPswd"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "password",
                  modelValue: form.oldPswd,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.oldPswd) = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "新密码",
              prop: "newPswd"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "password",
                  modelValue: form.newPswd,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.newPswd) = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "确认新密码",
              prop: "checkPswd"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "password",
                  modelValue: form.checkPswd,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.checkPswd) = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})